import React, { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { usePermission } from '@tomfxs/permissions-client'

import loadComponent from 'src/utils/loadMFE'
import RouteContainer from 'src/components/App/RouteContainer'

const AcademyUpdateForm = React.lazy(() => loadComponent('traiwiss', 'AcademyUpdateForm'))

export function AcademyDetailsRoute() {
    const params = useParams()
    const navigate = useNavigate()

    const canUpdate = usePermission('traiwiss.academy.update', {})
    const canDelete = usePermission('traiwiss.academy.delete', {})

    const onDelete = useCallback(() => {
        navigate('/academies')
    }, [navigate])

    const onUpdate = useCallback(() => {
        navigate('/academies')
    }, [navigate])

    return (
        <RouteContainer>
            <AcademyUpdateForm _id={params._id} canDelete={canDelete} canUpdate={canUpdate} onDelete={onDelete} onUpdate={onUpdate} />
        </RouteContainer>
    )
}
